/*
 * Autorska prava pridržava Mali mol d.o.o. Pula
 * Copyright (c) 2016. by Mali mol d.o.o. Pula. All rights reserved.
 *
 * Korištenje ili javno objavljivanje ovog programskog koda ili bilo kojeg
 * njegovog dijela, nije dozvoljeno bez prethodnog pismenog odobrenja tvrtke Mali mol d.o.o.
 *
 * Mali mol d.o.o., Špiljavac 2, 52100 Pula, Croatia
 * <URL:http://www.malimol.hr>, <mailto:info@malimol.hr>
 */

import { defineComponent, ref, computed, watch, onMounted } from 'vue';

import { useAuthStore } from '../../stores/auth';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'Navbar',
  emits: ['localeChanged'],
  setup(props, { emit }) {
    const authStore = useAuthStore();
    const { locale } = useI18n({ useScope: 'global' });
    const locales = ref([
      { lang: 'de', title: 'Deutsch', flag: 'images/germany.svg' },
      { lang: 'en', title: 'English', flag: 'images/united_kingdom.svg' },
      { lang: 'hr', title: 'Hrvatski', flag: 'images/croatia.svg' },
      { lang: 'nl', title: 'Nederlands', flag: 'images/netherland.svg' }
    ]);
    const currentLocale = ref(locales.value[0]);

    // const items = ref([
    //   {
    //     label: 'Browse',
    //     items: [
    //       {
    //         label: 'Sketches',
    //         to: '/'
    //       },
    //       {
    //         label: 'Work orders',
    //         to: '/work_orders'
    //       }
    //     ]
    //   },
    //   {
    //     label: 'Setup',
    //     items: [
    //       {
    //         label: 'Data',
    //         to: '/data'
    //       },
    //       {
    //         label: 'Administration',
    //         to: '/administration',
    //         visible: 'hasAdminAccess'
    //       },
    //       {
    //         label: 'Config',
    //         to: '/config',
    //         visible: 'hasConfigAccess'
    //       }
    //     ]
    //   }
    // ]);

    onMounted(() => {
      let found = locales.value.find((item) => item.lang == locale.value);
      currentLocale.value = found ? found : locales.value[0];
    });

    const hasAdminAccess = computed(() => {
      let admin = authStore.permissions.admin;
      return admin.read || admin.write;
    });

    const hasConfigAccess = computed(() => {
      let config = authStore.permissions.config;
      return config.read || config.write;
    });

    watch(currentLocale, () => {
      // locale.value = currentLocale.value.lang;
      emit('localeChanged', currentLocale.value.lang);
    });

    return {
      authStore,
      hasAdminAccess,
      currentLocale,
      locales,
      hasConfigAccess,
      // items
    };
  }
});
